import { Outlet, ScrollRestoration } from "react-router-dom";
import { Footer } from "../components/layout/Footer";
import { Header } from "../components/layout/Header";

export function SiteLayout() {
  return (
    <main className="app-shell">
      <Header />
      <Outlet />
      <Footer />
      <ScrollRestoration />
    </main>
  );
}
